import React from "react";

import WebUserStatus from "../../etc/list/WebUserStatus";

const WebCreateSubDomainInfo = ({ isStandardType, subDomain_info, goToPassListPage }) => {
    return (
        <tbody>
            {/* landscape-to-portrait 등 display:flex 클래스는 td가 아니라 td 내부 div에 적용
                (td 자체에 display:flex를 주면 table-cell 박스가 깨져 열 정렬이 무너짐) */}
            <tr>
                <td className="text-center">
                    {/* 260804 서브 도메인 이름 말줄임(...) 처리 - WebConfigSubDomainInfo.js와 동일한 문제/수정 */}
                    <div className="d-flex align-items-center justify-content-center admin-ellipsis-cell">
                        <span className="info title hiclass-text admin-ellipsis-text" title={subDomain_info.subDomainName}>{subDomain_info.subDomainName}</span>
                    </div>
                </td>
                <td className="small text-center">
                    <WebUserStatus kind={"userStatus"} memberCnt={subDomain_info.memberCnt} />
                </td>
                <td className="small text-center">
                    <div className="landscape-to-portrait">
                        <div className="list-row area-50">
                            <span className="only-mobile">T :&nbsp;</span>{subDomain_info.chatRoomCnt}
                        </div>
                        <div className="list-row area-50">
                            <span className="only-mobile">L :&nbsp;</span>
                            {
                                subDomain_info.liveOnCnt > 0 ?
                                    <span className="green-text font-weight-bold">{subDomain_info.liveOnCnt}</span> :
                                    <span>{subDomain_info.liveOnCnt}</span>
                            }
                            <span>&nbsp;{" / " + subDomain_info.liveCnt}</span>
                        </div>
                    </div>
                </td>
                <td className="text-center">
                    {
                        isStandardType &&
                        <button type="button" className="btn-table-action" onClick={() => goToPassListPage({ subDomainSeq: subDomain_info.subDomainSeq })}>
                            조회
                        </button>
                    }
                </td>
            </tr>
        </tbody>
    );
}

export default WebCreateSubDomainInfo;